<template>
<div class="loginapp">
  <div id="header"></div>
  <div class="login">
    <div id="login_title">
      <h2>{{SYS.systitle}}</h2>
      
  <h4 id="login_subtitle">{{SYS.subtitle}}</h4>
  <p id="login_p" style="font-size: 15px">
    {{SYS.content}}
  </p>
    </div>
    <div id="login_content">
      <div style="padding-top:120px;">
        <div>
          <input
              id="login_code"
              type="text"
              v-model="userName"
              class="login_code"
              placeholder="请输入用户名"
            />
        </div>
        <div>
          <input
              id="login_pwd"
              type="password"
              v-model="pwd"
              class="login_code"
              placeholder="请输入密码"
              autocomplete="off"
            />
        </div>
        <div style="display:flex;justify-content: center;">
          <input
                name="login_vcode"
                type="text"
                class="login_vcode"
                v-model="vcode"
                placeholder="请输入验证码"
                autocomplete="off"
              />
              <img :src="imgCode" @click="changeImgCode()" style="cursor:pointer;width:105px;height: 36px;"/>
          </div>
          <div>
            <input type="submit" @click="login()" class="loginbutton" value="登录"/>
          </div>
      </div>
      <!-- <table>
        <tr>
          <td style="height: 100px"></td>
        </tr>
        <tr>
          <td>
            <input
              id="login_code"
              type="text"
              v-model="userName"
              class="login_code"
              placeholder="请输入用户名"
            />
          </td>
        </tr>
        <tr>
          <td>
            <input
              id="login_pwd"
              type="password"
              v-model="pwd"
              class="login_code"
              placeholder="请输入密码"
              autocomplete="off"
            />
          </td>
        </tr>
        <tr><td>
          <div style="display:flex;justify-content: center;">
          <input
                name="login_vcode"
                type="text"
                class="login_vcode"
                v-model="vcode"
                placeholder="请输入验证码"
                autocomplete="off"
              />
              <img :src="imgCode" @click="changeImgCode()" style="cursor:pointer;width:105px;height: 36px;"/>
          </div>
          </td></tr>
        <tr>
          <td>
            <input type="submit" @click="login()" class="loginbutton" value="登录"></input>
          </td>
        </tr>
      </table> -->
    </div>
  </div>
  <div id="footer"></div>
  </div>
</template>

<script>
import copyright from "@/components/copyright";
export default {
  components: {
    copyright,
  },
  data() {
    return {
      userClass: "管理员",
      userName: "",
      pwd: "",
      vcode: "",
      imgCode:'/api/SYS/ValidateCode'
    };
  },
  created() {
    if (this.CU.cu.uclass)
      this.userClass = this.CU.cu.uclass;
    else 
      this.userClass = "管理员";
  },
  methods: {
    changeImgCode() {
      var num=Math.ceil(Math.random()*10);//生成一个随机数（防止缓存）
      this.imgCode = "/api/SYS/ValidateCode?" + num;
    },
    login() {
      const that = this;
      if(!that.userName){
        that.$alert('请输入用户名！', {
            title: "错误",
        });
        return;
      }
      if(!that.pwd){
        that.$alert('请输入密码！', {
            title: "错误",
        });
        return;
      }
      if(!that.vcode){
        that.$alert('请输入验证码！', {
            title: "错误",
        });
        return;
      }
      that.LOGIN(
        that.userName,
        that.pwd,
        that.vcode,
        function (res) {
          that.$UL.getlevels(function(){
            if(that.CU.cu.orgtype == "文明单位")
              that.$router.replace("/main/welcomewmdw");
            else
              that.$router.replace("/main/welcome");
          });
        },
        function (err) {
          console.log(err);
          that.$alert(err, {
            title: "错误",
          });
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>

// html,
// body,
// #app,
// .homebox,
// .el-container {
//   padding: 0px;
//   margin: 0px;
//   height: 100%;
// }
// #app{
//   // background-image: url('/static/xdj2.jpg');
//   // background-size:cover;
//   // background-repeat: round;
//   background-color: #F4E2CC;
// }
// #header{
//     position: absolute;
//     left: 0;
//     top: 0;
//     height: 394px;
//     width: 500px;
//     background-image: url(/static/gq.png);
//     background-repeat: no-repeat;
//     z-index: 6;
// }
// #footer{
//     position: absolute;
//     bottom: 0px;
//     margin: 0 0 0 0;
//     height: 861px;
//     width: 100%;
//     background-image: url(/static/cc.png);
//     background-repeat: no-repeat;
//     background-size: cover;
//     z-index: 5;
// }
// .login {
//   z-index: 999;
//   position: absolute;
//   right: 10%;
//   top: 25%;
//   width: 80%;
//   height: 380px;
//   text-align: center;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   h2{
//     color: #ff0000;
//   }
//   h4{
//     color: #272c29;
//   }
// }
// td{
//   text-align: center;
// }
// #login_title {
//   text-align: left;
//   font-size: 20px;
//   line-height: 30px;
//   color: #013818;
// }
// .login_code {
//   border: 0px;
//   border-bottom: 1px solid #878686;
//   background-color: transparent;
//   height: 35px;
//   margin: 0 0 15px 5px;
//   width: 240px;
//   font-size: 15px;
//   padding:0px 10px;
//   outline:0;
// }
// .login_vcode {
//   border: 0px;
//   border-bottom: 1px solid #878686;
//   background-color: transparent;
//   height: 35px;
//   margin: 0 0 15px 5px;
//   width: 140px;
//   font-size: 15px;
//   padding:0px 10px;
//   outline:0;
// }
// .loginbutton {
//   border: 1px solid #ff0000;
//   border-radius: 5px;
//   height: 45px;
//   padding-left: 10px;
//   margin: 0 0 15px 5px;
//   width: 250px;
//   font-size: 16px;
//   background-color: red;
//   color: white;
// }

// .login #login_content {
//   background-image: url("/static/login.png");
//   max-width: 377px;
//   height: 409px;
//   min-width: 377px;
// }

// #login_content table {
//   margin-left: 30px;
// }
</style>
